
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'


export default {
components: {
XHeader,
XImg
},
mounted () {
if(this.GLOBAL.currentUser==undefined){
this.$router.push({ path: '/' });
}
let path = this.$route.query.path;
if(path==''){
this.imgUrl=this.GLOBAL.noPicUrl;
}
else{
this.imgUrl=process.env.BASE_URL.replace("api/", "")+path.replace("\\","/");
}

},
methods: {
success (src, ele) {
console.log('success load', src)
const span = ele.parentNode.querySelector('span')
ele.parentNode.removeChild(span)
},
error (src, ele, msg) {
console.log('error load', msg, src)
const span = ele.parentNode.querySelector('span')
span.innerText = '图片加载失败...'
ele.parentNode.removeChild(span)
}
},

data () {
return {
imgUrl:''
}
}
}



// WEBPACK FOOTER //
// ./src/components/ShowImgPage.vue